<script>
export default {
  name: "InfiniteAutocomplete",
  props: {
    /**
     * バインドする値
     */
    value: {
      type: [String, Number, Object, Array],
      default: null,
    },
    /**
     * ラベル文字列
     */
    label: {
      type: String,
      default: () => null,
    },
    /**
     * プレースホルダー文字列
     */
    placeholder: {
      type: String,
      default: () => null,
    },
    /**
     * エラーメッセージ
     */
    errorMessages: {
      type: Array,
      default: () => [],
    },
    itemValue: {
      type: String,
      default: "value",
    },
    itemText: {
      type: String,
      default: "text",
    },
    /**
     * 展開するメンバー
     */
    members: {
      type: Array,
      default: () => [],
    },
    /**
     * ページネーション
     */
    pagination: {
      type: Object,
      default: () => ({
        next_page: null,
        prev_page: null,
        is_first_page: false,
        is_last_page: false,
      }),
    },
    /**
     * ローディング状態
     */
    loading: {
      type: Boolean,
      default: false,
    },
    /**
     * 無効化
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * 要素の境界の外側の角を丸める
     */
    rounded: {
      type: Boolean,
      default: false,
    },
    /**
     * クラスの追加
     */
    classes: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      selectableValue: null,
      searchKeyword: null,
      isComposition: false,
    };
  },
  watch: {
    value(val) {
      this.selectableValue = val;
    },
  },
  computed: {
    inputedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  methods: {
    /**
     * オートコンプリート チェンジイベント
     * ・設定済の変数のクリア処理をコール
     * ・メンバーの再読込
     */
    autocompleteChangeEvent(item) {
      const object = this.members.find((member) => member.value === item);
      this.$emit("change", object);
    },
    /**
     * クリアボタン クリックイベント
     */
    clearIconClickEvent() {
      this.searchKeyword = null;
      this.$emit("click:clear");
    },
    focusOutEvent() {
      this.searchKeyword = null;
    },
    enterKeydownEvent () {
      if (this.isComposition) {
        return;
      }

      this.$emit("keydown:enter", this.searchKeyword)
    },
    /**
     *
     * @param entries
     * @param observer
     * @param isIntersecting
     */
    endIntersect(entries, observer, isIntersecting) {
      if (isIntersecting && !this.loading) {
        this.$emit("insect");
      }
    },
    onSearchInput() {
      this.$emit("update:search-input", this.searchKeyword);
    },
    // 既存のメソッド
    onFocus() {
      this.$emit('focus');
    },
    focusIn () {
      this.$nextTick(() => {
        this.$refs.control.focus()
      })
    },
    /**
     *  IME などのテキスト変換システムが新しい変換セッションを開始した時に発火
     */
    compositionStartEvent () {
      this.isComposition = true
    },
    /**
     * IME などのテキスト編集システムが現在の編集セッションを完了またはキャンセルした時に発火
     */
    compositionEndEvent () {
      this.isComposition = false
      this.$emit("keydown:enter", this.searchKeyword)
    },

  },
};
</script>
<template>
  <div class="infinite-autocomplete-layer">
    <v-autocomplete
      v-model="inputedValue"
      ref="control"
      :class="classes"
      :disabled="disabled"
      :error-messages="errorMessages"
      :items="members"
      :item-value="itemValue"
      :item-text="itemText"
      :label="label"
      :loading="loading"
      :rounded="rounded"
      :placeholder="placeholder"
      :search-input.sync="searchKeyword"
      clearable
      dense
      hide-details="auto"
      outlined
      persistent-placeholder
      @change="autocompleteChangeEvent"
      @click:clear="clearIconClickEvent"
      @focusout="focusOutEvent"
      @focus="onFocus"
      @update:search-input="onSearchInput"
      @keydown.enter="enterKeydownEvent"
      @compositionstart="compositionStartEvent"
      @compositionend="compositionEndEvent"
    >
      <template v-slot:prepend>
        <slot name="prepend" />
      </template>

      <template v-slot:prepend-inner>
        <slot name="prepend-inner" />
      </template>

      <template v-slot:selection="scope">
        <slot name="selection" v-bind="scope">
          {{ scope.item[itemText] }}
        </slot>
      </template>

      <template v-slot:item="scope">
        <slot name="item" v-bind="scope">
          {{ scope.item[itemText] }}
        </slot>
      </template>

      <template v-slot:append-item>
        <div v-if="!pagination.is_last_page" v-intersect="endIntersect" />
      </template>

      <template v-slot:append>
        <slot name="append" />
      </template>

      <template v-slot:append-outer>
        <slot name="append-outer" />
      </template>
    </v-autocomplete>
  </div>
</template>
<style  lang="scss">
.v-autocomplete.v-input--hide-details .v-select__selections {
  & input {
    //display: none;
  }
}

</style>
